import { queryOptions } from '@tanstack/react-query';

import type { SymbolKey } from '@/entities/symbol';

import { fetchSymbolData } from './fetchSymbolData';

export const symbolPreviewOptions = {
  bySymbol: (symbol: SymbolKey, date: string) =>
    queryOptions({
      queryKey: ['symbol', symbol, date] as const,
      queryFn: () => fetchSymbolData(symbol, date)
    })
};
